export const PERSONALITIES = [
  { id: 'friendly_pro', label: 'Friendly Pro', emoji: '🛠', desc: 'Warm, encouraging mentor' },
  { id: 'comedian', label: 'Comedian', emoji: '😂', desc: 'Dad jokes between the steps' },
  { id: 'roast', label: 'Roast Mode', emoji: '🔥', desc: 'Playful roasts, still helpful' },
  { id: 'drill_sergeant', label: 'Drill Sergeant', emoji: '🎯', desc: 'Sharp, curt, no fluff' },
  { id: 'zen', label: 'Zen Master', emoji: '🧘', desc: 'Calm, philosophical' },
  { id: 'southern', label: 'Southern Charm', emoji: '🤠', desc: "Folksy y'all vibes" },
  { id: 'bro', label: 'The Bro', emoji: '🏄', desc: 'Bro. Dude. Gnarly.' },
];
